import { apiSlice } from '../../api';
import type {
  CreateWalletMerchantDTO,
  CreateWalletMerchantResult,
  DepositFiatWalletDTO,
  DepositFiatWalletResult,
  GetProfileWalletsDTO,
  GetProfileWalletsResult,
  GetWalletBlockchainBalanceDTO,
  GetWalletBlockchainBalanceResult,
  UpdateWalletProviderDTO,
  UpdateWalletProviderResult,
  WithdrawFiatWalletDTO,
  WithdrawFiatWalletResult,
} from './types';

export const adminWalletsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getProfileWallets: build.query<GetProfileWalletsResult, GetProfileWalletsDTO>({
        query: ({ profileUid }) => {
          return {
            url: `/admin/v1/profiles/${profileUid}/wallets`,
            method: 'GET',
          };
        },
        providesTags: ['Wallets'],
      }),

      depositFiatWallet: build.mutation<DepositFiatWalletResult, DepositFiatWalletDTO>({
        query: ({ walletUid, body }) => {
          return {
            url: `/admin/v1/wallets/${walletUid}/deposit/fiat`,
            method: 'POST',
            body,
            headers: {
              ['confirm-action-code']: body.password,
            },
          };
        },
        invalidatesTags: ['Wallets'],
      }),

      withdrawFiatWallet: build.mutation<WithdrawFiatWalletResult, WithdrawFiatWalletDTO>({
        query: ({ walletUid, body }) => {
          return {
            url: `/admin/v1/wallets/${walletUid}/withdrawal/fiat`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: ['Wallets'],
      }),

      updateWalletProvider: build.mutation<UpdateWalletProviderResult, UpdateWalletProviderDTO>({
        query: ({ walletUid, body }) => {
          return {
            url: `/admin/v1/wallets/${walletUid}/provider`,
            method: 'PUT',
            body,
          };
        },
        invalidatesTags: ['Wallets'],
      }),

      getWalletBlockchainBalance: build.query<
        GetWalletBlockchainBalanceResult,
        GetWalletBlockchainBalanceDTO
      >({
        query: ({ walletUid }) => ({
          url: `/admin/v1/wallets/${walletUid}/blockchain-balance`,
          method: 'GET',
        }),
      }),

      createWalletMerchant: build.mutation<CreateWalletMerchantResult, CreateWalletMerchantDTO>({
        query: ({ profile_uid, body }) => ({
          url: `/admin/v1/profiles/${profile_uid}/wallets/merchant`,
          method: 'POST',
          body,
        }),
      }),
    };
  },
});

export const { useGetProfileWalletsQuery, useLazyGetProfileWalletsQuery } = adminWalletsEndpoints;
export const { useDepositFiatWalletMutation } = adminWalletsEndpoints;
export const { useWithdrawFiatWalletMutation } = adminWalletsEndpoints;
export const { useLazyGetWalletBlockchainBalanceQuery } = adminWalletsEndpoints;
export const { useCreateWalletMerchantMutation } = adminWalletsEndpoints;
export const { useUpdateWalletProviderMutation } = adminWalletsEndpoints;

export type AdminWalletsController = typeof adminWalletsEndpoints;
